import { render } from "./GarantidorasView.vue?vue&type=template&id=5fc49aae&scoped=true"
import script from "./GarantidorasView.vue?vue&type=script&lang=js"
export * from "./GarantidorasView.vue?vue&type=script&lang=js"

import "./GarantidorasView.vue?vue&type=style&index=0&id=5fc49aae&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc49aae"]])

export default __exports__